import React from "react";

const ProductAdmin = () => {
  return <div>ProductAdmin</div>;
};

export default ProductAdmin;
